import { render } from "./CognitoLoginPopup.vue?vue&type=template&id=4c6ae7ae"
import script from "./CognitoLoginPopup.vue?vue&type=script&lang=js"
export * from "./CognitoLoginPopup.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__